var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Dialog.styles.scss';
import { Title } from '../Title';
import { Button } from '../Button';
var Dialog = function (_a) {
    var _b = _a.title, title = _b === void 0 ? '' : _b, _c = _a.dialogSize, dialogSize = _c === void 0 ? 'md' : _c, textContent = _a.textContent, actions = _a.actions;
    return (_jsx("div", __assign({ className: "hefesto-dialog__overlay" }, { children: _jsxs("div", __assign({ className: "hefesto-dialog__container hefesto-dialog__container--".concat(dialogSize), "data-testid": "dialog-container" }, { children: [_jsx("div", __assign({ className: "hefesto-dialog__header" }, { children: _jsx(Title, __assign({ level: 3 }, { children: title })) })), _jsx("p", __assign({ className: "hefesto-dialog__body" }, { children: textContent })), _jsxs("div", __assign({ className: "hefesto-dialog__footer" }, { children: [!!actions.left && (_jsx(Button, __assign({}, actions.left, { type: "button", variant: "secondary" }, { children: actions.left.children }))), _jsx(Button, __assign({}, actions.right, { type: "button", variant: "primary" }, { children: actions.right.children }))] }))] })) })));
};
export default Dialog;
